export default __webpack_public_path__ + "7e41164a48d430af0a7b048699868af3.svg";